import { getAxios } from '@parchment/oauth2-axios';
import { GET_EXTERNAL_EVIDENCE_START, GET_EXTERNAL_EVIDENCE_DONE, GET_EXTERNAL_EVIDENCE_ERROR } from './index';
import { CREDENTIAL_ACCOUNT_RESOURCE_KEY } from '../utils';

export function getExternalEvidence(externalEvidenceId) {
    const url = `/external-evidence/${externalEvidenceId}`;
    return (dispatch) => {
        dispatch({
            type: GET_EXTERNAL_EVIDENCE_START
        });

        return getAxios(CREDENTIAL_ACCOUNT_RESOURCE_KEY).get(url).then((response) => {
            dispatch({
                type: GET_EXTERNAL_EVIDENCE_DONE,
                payload: response
            });
        }).catch((error) => {
            dispatch({
                type: GET_EXTERNAL_EVIDENCE_ERROR,
                payload: error.response
            });
        });
    };
}

